const moneyFromCents = cents => `$${(Number(cents || 0) / 100).toFixed(2)}`;
let cartState = { items: [], item_count: 0, items_subtotal_price: 0 };

const cartEl = document.querySelector('#cart');
const scrimEl = document.querySelector('#scrim');
const statusEl = document.querySelector('#cart-status');
const checkoutEl = document.querySelector('.checkout');

function initHeroVideo() {
  const video = document.querySelector('.hero-video');
  const playButton = document.querySelector('.hero-video-play');
  if (!video || !playButton) return;

  const showFallback = () => { playButton.hidden = false; };
  const hideFallback = () => { playButton.hidden = true; };
  const tryPlay = () => {
    video.muted = true;
    const attempt = video.play();
    if (attempt?.then) attempt.then(hideFallback).catch(showFallback);
  };

  video.addEventListener('playing', hideFallback);
  video.addEventListener('error', showFallback);
  playButton.addEventListener('click', tryPlay);

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) tryPlay();
        else video.pause();
      });
    }, { threshold: .2 });
    observer.observe(video);
  } else {
    tryPlay();
  }
}

function announce(message) {
  if (statusEl) statusEl.textContent = message;
}

function openCart() {
  cartEl?.classList.add('open');
  scrimEl?.classList.add('show');
  cartEl?.setAttribute('aria-hidden', 'false');
  document.querySelector('#close-cart')?.focus();
}

function closeCart() {
  cartEl?.classList.remove('open');
  scrimEl?.classList.remove('show');
  cartEl?.setAttribute('aria-hidden', 'true');
}

function updateCard(card) {
  const mode = card.dataset.mode || 'once';
  const once = Number(card.dataset.oncePrice);
  const partner = Number(card.dataset.partnerPrice);
  const cartonQty = Number(card.dataset.cartonQty || 0);
  const oneOffQty = Number(card.querySelector('.once-qty select')?.value || 1);
  const cartonUnlocked = mode === 'once' && cartonQty > 0 && oneOffQty >= cartonQty;

  card.querySelectorAll('.pricing-toggle button').forEach(button => {
    const active = button.dataset.mode === mode;
    button.classList.toggle('active', active);
    button.setAttribute('aria-pressed', String(active));
  });
  card.querySelector('.once-qty')?.classList.toggle('show', mode === 'once');
  card.querySelector('.monthly-qty')?.classList.toggle('show', mode === 'partner');
  card.querySelector('.price').innerHTML = mode === 'partner'
    ? `$${partner.toFixed(2)} <small>${card.dataset.unitLabel} / month</small>`
    : cartonUnlocked
      ? `$${partner.toFixed(2)} <small>${card.dataset.unitLabel} · $${(partner * oneOffQty).toFixed(2)} total</small>`
      : `$${once.toFixed(2)} <small>${card.dataset.unitLabel}</small>`;

  const saving = card.querySelector('.saving');
  if (saving) saving.textContent = mode === 'partner'
    ? `Save $${(once - partner).toFixed(2)} per ${card.dataset.countLabel}`
    : cartonUnlocked
      ? `Save $${((once - partner) * oneOffQty).toFixed(2)} on this order`
      : '';

  const unlock = card.querySelector('.carton-unlock');
  if (unlock) {
    unlock.hidden = mode !== 'once';
    const remaining = Math.max(0, cartonQty - oneOffQty);
    const progress = Math.min(100, (oneOffQty / cartonQty) * 100);
    const title = unlock.querySelector('.carton-unlock-title');
    const status = unlock.querySelector('.carton-unlock-status');
    const track = unlock.querySelector('.carton-track');
    if (title) title.textContent = cartonUnlocked ? 'Full-carton price unlocked' : `Unlock $${partner.toFixed(2)} per box`;
    if (status) status.textContent = cartonUnlocked
      ? `${oneOffQty} boxes · save $${((once - partner) * oneOffQty).toFixed(2)}`
      : `${remaining} more box${remaining === 1 ? '' : 'es'} to unlock`;
    if (track) {
      track.setAttribute('aria-valuenow', String(Math.min(oneOffQty, cartonQty)));
      track.querySelector('span').style.width = `${progress}%`;
    }
    unlock.classList.toggle('unlocked', cartonUnlocked);
  }
}

function setOrderMode(mode) {
  document.querySelectorAll('.order-type-button').forEach(button => {
    const active = button.dataset.orderMode === mode;
    button.classList.toggle('active', active);
    button.setAttribute('aria-pressed', String(active));
  });

  document.querySelectorAll('.product[data-once-price]').forEach(card => {
    card.dataset.mode = mode;
    updateCard(card);
  });

  const helper = document.querySelector('#order-mode-help');
  if (helper) helper.textContent = mode === 'partner'
    ? 'Choose any mix below. Every monthly item gets Partner Pricing and renews each month.'
    : 'Choose quantities below for a single order with no recurring charge.';
}

function subscriptionSummary(items) {
  const monthly = items.filter(item => item.selling_plan_allocation);
  if (!monthly.length) return '';
  const monthlyTotal = monthly.reduce((sum, item) => sum + item.final_line_price, 0);
  const monthlySaving = monthly.reduce((sum, item) => {
    const compareAt = item.selling_plan_allocation?.compare_at_price;
    const original = Number.isFinite(compareAt)
      ? compareAt * item.quantity
      : (item.original_line_price ?? item.final_line_price);
    return sum + Math.max(0, original - item.final_line_price);
  }, 0);
  return `<div class="monthly-cart-summary"><strong>Monthly supply</strong><span>${monthly.length} product${monthly.length === 1 ? '' : 's'} · ${moneyFromCents(monthlyTotal)} / month</span>${monthlySaving ? `<small>You save ${moneyFromCents(monthlySaving)} each month.</small>` : ''}</div>`;
}

function renderCart() {
  const count = document.querySelector('#cart-count');
  const itemsEl = document.querySelector('#cart-items');
  const total = document.querySelector('#cart-total');
  if (count) count.textContent = cartState.item_count || 0;
  if (total) total.textContent = moneyFromCents(cartState.items_subtotal_price);

  if (itemsEl) {
    itemsEl.innerHTML = cartState.items.length
      ? subscriptionSummary(cartState.items) + cartState.items.map(item => {
          const monthly = Boolean(item.selling_plan_allocation);
          const discountTitle = item.line_level_discount_allocations?.[0]?.discount_application?.title || '';
          const planName = item.selling_plan_allocation?.selling_plan?.name || '';
          return `<div class="cart-line"><div><strong>${item.product_title || item.title}</strong><br><span>${monthly ? 'Monthly supply' : discountTitle ? `Full carton · ${discountTitle}` : 'One-off'} · ${item.quantity}${monthly && planName ? ` · ${planName}` : ''}</span><button class="remove" data-key="${item.key}">Remove</button></div><strong>${moneyFromCents(item.final_line_price)}</strong></div>`;
        }).join('')
      : '<p>Your cart is empty.</p>';
  }

  checkoutEl?.setAttribute('aria-disabled', String(!cartState.items.length));
  checkoutEl?.classList.toggle('disabled', !cartState.items.length);

  document.querySelectorAll('.remove').forEach(button => {
    button.addEventListener('click', async () => {
      button.disabled = true;
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: button.dataset.key, quantity: 0 })
      });
      if (!response.ok) {
        button.disabled = false;
        announce('We could not remove that item. Please try again.');
        return;
      }
      cartState = await response.json();
      renderCart();
      announce('Item removed.');
    });
  });
}

async function refreshCart() {
  const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
  if (!response.ok) throw new Error('Unable to load cart');
  cartState = await response.json();
  renderCart();
}

document.querySelectorAll('.order-type-button').forEach(button => {
  button.addEventListener('click', () => setOrderMode(button.dataset.orderMode));
});

document.querySelectorAll('.product[data-once-price]').forEach(card => {
  card.dataset.mode = 'once';
  card.querySelectorAll('.pricing-toggle button').forEach(button => {
    button.addEventListener('click', () => {
      card.dataset.mode = button.dataset.mode;
      updateCard(card);
    });
  });
  card.querySelectorAll('select').forEach(select => select.addEventListener('change', () => updateCard(card)));
  card.querySelector('.carton-jump')?.addEventListener('click', () => {
    const select = card.querySelector('.once-qty select');
    if (!select) return;
    select.value = card.dataset.cartonQty;
    updateCard(card);
    select.focus();
  });

  card.querySelector('.add')?.addEventListener('click', async event => {
    const button = event.currentTarget;
    const mode = card.dataset.mode;
    const monthly = mode === 'partner';
    const quantity = Number(card.querySelector(monthly ? '.monthly-qty select' : '.once-qty select').value);
    const sellingPlan = Number(card.dataset.sellingPlanId || 0);

    if (monthly && !sellingPlan) {
      announce('Monthly pricing is temporarily unavailable for this product.');
      return;
    }

    const item = { id: Number(card.dataset.variantId), quantity };
    if (monthly) item.selling_plan = sellingPlan;

    button.disabled = true;
    button.textContent = 'Adding…';
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    });
    button.disabled = false;
    button.textContent = 'Add to order';

    if (!response.ok) {
      announce('This product could not be added. Please check the quantity or contact us.');
      return;
    }

    await refreshCart();
    announce(`${card.querySelector('h3').innerText} added to ${monthly ? 'your monthly supply' : 'your order'}.`);
    openCart();
  });
  updateCard(card);
});

document.querySelector('.cart-button')?.addEventListener('click', openCart);
document.querySelector('#close-cart')?.addEventListener('click', closeCart);
scrimEl?.addEventListener('click', closeCart);
checkoutEl?.addEventListener('click', event => {
  if (!cartState.items.length) event.preventDefault();
});
document.addEventListener('keydown', event => {
  if (event.key === 'Escape') closeCart();
});

setOrderMode('once');
initHeroVideo();
refreshCart().catch(() => announce('Your cart could not be loaded. Refresh the page and try again.'));
